import {
  SLTXFormatRootFile,
  SLTXFormatRootFileGroup,
  SLTXFormatRootFileGroupOption,
} from './sltx';

//-------------------------------------------------------------------------
// class ModelGroupInfo
// This class simply helps retrieve information about groups and options
// of a given SLTX file.
//-------------------------------------------------------------------------

export class ModelGroupInfo {

  public static getGroupRootOptions(
    group : SLTXFormatRootFileGroup,
  ) : SLTXFormatRootFileGroupOption[] {
    const groupRootFolder = group.optionsFolders.find((o) => o.name === 'Root');
    if (groupRootFolder === undefined) {
      return [];
    }

    return groupRootFolder.options;
  }

  public static getGroupAllOptions(
    group : SLTXFormatRootFileGroup,
  ) : SLTXFormatRootFileGroupOption[] {

    const options = group.optionsFolders.flatMap((f) => f.options);
    return options;
  }

  public static getFolderWithOptions(
    group : SLTXFormatRootFileGroup,
  ) : Map<string, SLTXFormatRootFileGroupOption[]> {
    const groupOptions = new Map<string, SLTXFormatRootFileGroupOption[]>();
    group.optionsFolders.forEach((folder) => {
      groupOptions.set(folder.name, folder.options);
    });

    return groupOptions;
  }

  public static getOptionFolderName(
    group : SLTXFormatRootFileGroup,
    id : number,
  ) : string | undefined {

    let name = 'Root';
    group.optionsFolders.forEach((folder) => {
      folder.options.forEach((opt) => {
        if (opt.id === id) {
          name = folder.name;
        }
      });
    });

    return name === 'Root' ? '' : name;
  }

  public static getGroupName(
    sltxFile : SLTXFormatRootFile,
    groupID : number,
  ) : string | undefined {

    const group = this.getGroup(sltxFile, groupID);
    if (group === undefined) {
      return undefined;
    }

    return group.name;
  }

  public static getGroup(
    sltxFile : SLTXFormatRootFile,
    groupID : number,
  ) : SLTXFormatRootFileGroup | undefined {
    const { groups } = sltxFile;
    if (groups === undefined) {
      return undefined;
    }

    const group = groups.find((g) => g.id === groupID);
    return group;
  }

  public static getOption(
    sltxFile : SLTXFormatRootFile,
    groupID : number,
    optionID : number,
  ) : SLTXFormatRootFileGroupOption | undefined {

    const group = this.getGroup(sltxFile, groupID);
    if (group === undefined) {
      return undefined;
    }

    const options = this.getGroupAllOptions(group);

    return options.find((o) => o.id === optionID);
  }
}
